import { StyleSheet } from "aphrodite";

export default StyleSheet.create({
  header: {
    height: 70,
    width: "100%"
  }
});
